angular
  .module('surfsightApp.controllers')
  .controller('organizationChangeController', [
    '$rootScope',
    '$scope',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    '$interval',
    'userOrganizationsList',
    function (
      $rootScope,
      $scope,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdToast,
      $interval,
      userOrganizationsList
    ) {
      $scope.userOrganizationsList = userOrganizationsList
      $scope.organizationListView = true
      $scope.reasonForm = {}
      $scope.userOrganizations = []
      $scope.search = {}
      $scope.search.text = ''
      $scope.SearchFilter = function (item) {
        var searchingAttributes = ['name']
        if (item) {
          for (var i = 0; i < searchingAttributes.length; i++) {
            if (
              item[searchingAttributes[i]]
                .toLowerCase()
                .indexOf($scope.search.text.toLowerCase()) != -1
            ) {
              return true
            }
          }
          return false
        }
      }
      var request_json = {
        method: 'GET',
        url: V2_BASEURL + '/organizations'
      }
      $http(request_json).then(function (response) {
        var organizations = response.data.data.map(o => {
          o.name = o.name.replace(/&amp;/g, '&')
          return o
        })
        var count = organizations.length
        for (var i = 0; i < count; i++) {
          $scope.userOrganizations.push(organizations[i])
        }
      })
      function closeDialog (userOrganization) {
        $mdDialog.hide(userOrganization)
      }
      $scope.updateOrganization = function (userOrganization) {
        $scope.organizationListView = false
        $scope.userOrganization = userOrganization
      }
      $scope.saveOraganizationChangeReason = function (form) {
        $scope.reasonForm.userId = $localStorage.userDetails.id
        $scope.reasonForm.organizationId =
          $localStorage.currentUserOrganization.id
        $scope.reasonForm.organizationName =
          $localStorage.currentUserOrganization.name
        $scope.reasonForm.email = $localStorage.userDetails.email
        if ($localStorage.isResellerSso) {
          // if user is a reseller skip reason update
          $rootScope.$emit('refreshUserPermissions', {})
          $mdDialog.hide($scope.userOrganization)
        } else if ($scope.reasonForm.reason) {
          $scope.reasonForm.newOrganizationId = $scope.userOrganization.id
          $scope.reasonForm.newOrganizationName = $scope.userOrganization.name
          var request_json = {
            method: 'POST',
            url: USER_BASEURL + '/userOrganizationLog/',
            data: $scope.reasonForm
          }
          $http(request_json).then(function (response) {
            if (response.data.status.code == 0) {
              $rootScope.$emit('refreshUserPermissions', {})
              $mdDialog.hide($scope.userOrganization)
              $rootScope.alarmsCount = response.data.alarmsCount
              $localStorage.alarmsCount = response.data.alarmsCount
            }
          })
        } else {
          alert('Please enter reason')
          return false
        }
        // console.log($scope.reasonForm)
        $scope.cancel = function () {
          $mdDialog.cancel()
        }
      }

      $scope.cancel = function () {
        $mdDialog.cancel()
      }
    }
  ])
